import React from 'react';
import AboutSection from '../components/AboutSection';
import IntroParallaxSection from '../components/IntroParallaxSection'; // We'll use this here
import AboutSmartlight from '../components/AboutSmartlight';
import WhoWeAre from '../components/WhoWeAre';
import OurTeam from '../components/OurTeam';
import FoundersSection from '../components/FoundersSection';

export default function AboutPage() {
  return (
    <main>
      <AboutSmartlight />
      <AboutSection />
      <WhoWeAre />
      <FoundersSection />
      <OurTeam />
      {/* You could add more sections specific to the About page here */}
    </main>
  );
}